import { omit } from 'lodash-es';
import request from './request';

const removeFnFromProps = (props: any, fnList: any) => {
  return omit(props, fnList);
};
const getQueryVariable = (variable: string) => {
  const query = window.location.href.split('?')[1];
  if (query) {
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
  }
  return '';
};

const formatNumber = (number: number, n: number = 2) => {
  return Math.round(number * Math.pow(10, n)) / Math.pow(10, n);
};

const is_weixn = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  const match = ua.match(/MicroMessenger/i);
  if (match === null) {
    return false;
  }
  if (match.includes('micromessenger')) {
    return true;
  }
  return false;
};

const isSafari = () => {
  const userAgent = navigator.userAgent;
  // 检测WebKit内核且不是Chrome、Edge等基于Chromium的浏览器
  return (
    /WebKit/i.test(userAgent) &&
    !/Chrome/i.test(userAgent) &&
    !/Chromium/i.test(userAgent) &&
    !/Edge/i.test(userAgent) &&
    !/OPR/i.test(userAgent)
  );
};
const getStorage = (key: string) => {
  return localStorage.getItem(key);
};
const setStorage = (key: string, token: string) => {
  return localStorage.setItem(key, token);
};
const removeStorage = (key: string) => {
  localStorage.removeItem(key);
};

const formatEnumToArray = (
  Enum: Record<string, string> | Map<boolean, string>,
) => {
  return Object.entries(Enum).map(([value, label]) => ({
    label,
    value,
  }));
};

export {
  formatEnumToArray,
  formatNumber,
  getQueryVariable,
  getStorage,
  is_weixn,
  isSafari,
  removeFnFromProps,
  removeStorage,
  request,
  setStorage,
};
